<template>
  <div class="mobileheaderback">
    <div class="row align-items-center">
      <div class="col-2">
        <button
          class="navbar-toggler mobile-sidebar-toggler"
          type="button"
          id="mobile-header-back-button"
          @click.prevent="$router.back()"
										data-test="mobileHeaderBackBtn"
        >
          <i class="fa fa-chevron-left"
													data-test="mobileHeaderBackIcon" id="mobileHeaderBackIcon"></i>
        </button>
      </div>
      <div class="col p-0 m-0">
        <span class="description text-capitalize"
														data-test="mobileHeaderBackSpan" id="mobileHeaderBackSpan">
          {{$route.query.display_text}}
        </span>
      </div>
      <div class="col-4 wp_alignContent">
        <cart-button v-if="$route.path !== '/cart' &&
                          $route.path !== '/order-success' &&
                          !($route.query.token)">
        </cart-button>
      </div>
    </div>
  </div>
</template>

<script>
// import Search from '@/components/widgets/search/Search'
import CartButton from '@/components/shared/widgets/CartButton'

export default {
	components: {
		// Search,
		CartButton
	}
}
</script>

<style>
</style>
